const featurePolicyIncludesStatementLevel = (feature, expectedLevel) => {
    const expectedToken = String(expectedLevel ?? '').trim();
    if (!expectedToken) return false;

    return (feature?.policy?.statements ?? []).some((statement) => {
        const statementType = String(statement?.type ?? '').trim().toLowerCase();
        if (statementType && statementType !== 'level') {
            return false;
        }

        const tokens = String(statement?.statement ?? '')
            .split(',')
            .map((token) => token.trim())
            .filter(Boolean);
        return tokens.includes(expectedToken);
    });
};

const findPlanFeature = (plan, featureNames) => {
    const normalizedFeatureNames = Array.isArray(featureNames) ? featureNames : [featureNames];

    return (plan?.features ?? []).find((feature) => normalizedFeatureNames.includes(feature?.name)) ?? null;
};

export const hasPremiumAssetsAccess = (plan) => {
    return featurePolicyIncludesStatementLevel(findPlanFeature(plan, ['assets-download', 'asset-download']), '1');
};

export const hasActivePremiumAssetsSubscription = (user) => {
    return user?.team?.subscription?.state === 'active'
        && hasPremiumAssetsAccess(user?.team?.subscription?.plan);
};

export const hasPremiumPluginsAccess = (plan) => {
    return featurePolicyIncludesStatementLevel(findPlanFeature(plan, 'apps-tier-access'), '1');
};

export const getMembershipLevelLabel = (plan) => {
    if (!plan) return 'Free';

    const hasPremiumAssetsLevel = hasPremiumAssetsAccess(plan);
    const hasPremiumPluginsLevel = hasPremiumPluginsAccess(plan);
    const price = Number(plan?.price ?? 0);
    const productName = String(plan?.product?.name ?? '').trim().toUpperCase();

    if (productName.includes('ENTERPRISE') || productName.includes('EDUCATORS')) return 'Enterprise';
    if (hasPremiumAssetsLevel) return 'PRO';
    if (!hasPremiumAssetsLevel && hasPremiumPluginsLevel) return 'Plugins Only';
    if (price > 0) return 'Skills';
    return 'Free';
};
